(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids-giveback-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!document.querySelector('.kids-giveback')) return;

    const hideLaunchers = () => {
      ['zeik0-widget-container', 'smile-ui-lite-launcher-frame-container'].forEach((id) => {
        const launcher = document.getElementById(id);
        if (launcher && launcher.style.getPropertyValue('display') !== 'none') {
          launcher.style.setProperty('display', 'none', 'important');
        }
      });
    };

    hideLaunchers();
    new MutationObserver(hideLaunchers).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salty-girls-launch"] && !Shopify.designMode) return;
  try {
    
  class SaltyGirlsLaunch extends HTMLElement {
    connectedCallback() {
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.products = Array.from(this.querySelectorAll('[data-salty-product]'));
      this.revealItems = Array.from(this.querySelectorAll('[data-salty-reveal]'));
      this.filters.forEach((button) => button.addEventListener('click', () => this.setFilter(button.dataset.filter, button)));
      this.setupColorPreviews();
      this.observeReveals();
    }

    setupColorPreviews() {
      this.querySelectorAll('[data-salty-color-preview]').forEach((swatch) => {
        const product = swatch.closest('[data-salty-product]');
        const preview = swatch.dataset.saltyColorPreview;

        if (!product) return;

        swatch.addEventListener('pointerenter', () => this.showColorPreview(product, preview));
        swatch.addEventListener('pointerleave', () => this.restoreColorPreview(product));
        swatch.addEventListener('focus', () => this.showColorPreview(product, preview));
        swatch.addEventListener('blur', () => this.restoreColorPreview(product));
      });
    }

    showColorPreview(product, preview) {
      if (preview !== 'grey') {
        this.restoreColorPreview(product);
        return;
      }

      const previewImage = product.querySelector('.salty-girls__product-image--preview');

      if (!previewImage) return;

      product.dataset.saltyColorPreview = preview;

      const activatePreview = () => {
        if (product.dataset.saltyColorPreview === preview) {
          product.classList.add('is-grey-preview');
        }
      };

      if (previewImage.complete && previewImage.naturalWidth > 0) {
        activatePreview();
        return;
      }

      previewImage.addEventListener('load', activatePreview, { once: true });
      previewImage.addEventListener('error', () => this.restoreColorPreview(product), { once: true });
    }

    restoreColorPreview(product) {
      delete product.dataset.saltyColorPreview;
      product.classList.remove('is-grey-preview');
    }

    setFilter(filter, activeButton) {
      const update = () => {
        this.filters.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        this.products.forEach((product) => {
          const shouldShow = filter === 'all' || product.dataset.style === filter;
          product.classList.toggle('is-hidden', !shouldShow);
        });
      };

      if (document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    observeReveals() {
      if (!('IntersectionObserver' in window)) {
        this.revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18 });

      this.revealItems.forEach((item) => observer.observe(item));
    }
  }

  if (!customElements.get('salty-girls-launch')) {
    customElements.define('salty-girls-launch', SaltyGirlsLaunch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salty-sale-event"] && !Shopify.designMode) return;
  try {
    
  if (!window.SaltySaleEvent) {
    window.SaltySaleEvent = true;
    document.addEventListener('click', function(event) {
      var link = event.target.closest('.salty-sale-event a[href^="#"]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      if (!document.startViewTransition) return;
      event.preventDefault();
      document.startViewTransition(function() {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
